import { ToolsTranslations } from '@/lib/translations/types';

export interface YieldOnCostValues { averageCostPerShare: number; dividendPerShare: number }
export interface YieldOnCostResult { percent: number | null; isValid: boolean; message?: string }

// Yield on Cost (%) = Dividend per share / Average cost per share * 100
export function calculateYieldOnCost(values: YieldOnCostValues, t?: ToolsTranslations['yieldOnCost']): YieldOnCostResult {
  const { averageCostPerShare, dividendPerShare } = values;
  if (averageCostPerShare <= 0) return { percent: null, isValid: false, message: t?.invalid.averageCostPerShare };
  if (dividendPerShare < 0) return { percent: null, isValid: false, message: t?.invalid.dividendPerShare };
  const percentRaw = (dividendPerShare / averageCostPerShare) * 100;
  const percent = Math.round(percentRaw * 10) / 10; // 1 decimal per screenshot 8.0 %
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


